import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StarratingComponent } from './starrating.component';

const routes: Routes = [
  { path: '', component: StarratingComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StarratingRoutingModule { }
